export const ENV = process.env.NODE_ENV;
export const MOCKY = !!process.env.REACT_APP_MOCKY;
export const CHUCK_BASE_URL = process.env.REACT_APP_CHUCK_DOMAIN;
export const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE;
export const HELLOSIGN_CLIENT_ID = process.env.REACT_APP_HELLOSIGN_CLIENT_ID;
export const GOOGLE_PLACES_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;
